let timestamp = {
    date: null,
    timezone: 'UTC',
    timezone_type: 3
};

let country = {
    id: null,
    abbr: null,
    name: null
};

let region = {
    id: null,
    abbr: null,
    name: null,
    country: _.clone(country)
};

let landowner = {
    id: null,
    first_name: null,
    last_name: null,
    email: null,
    phone: null,
    company: null,
    address: null,
    locality: null,
    region_id: null,
    postal_code: null,
    created_at: _.clone(timestamp),
    updated_at: _.clone(timestamp)
};

let property = {
    id: null,
    pid: null,
    geom: null,
    region: _.cloneDeep(region)
};

let plan = {
    id: null,
    data: null,
    // properties: [],
    created_at: _.clone(timestamp),
    updated_at: _.clone(timestamp)
    // region: _.cloneDeep(region)
};

let contact = {
    first_name: null,
    middle_name: null,
    last_name: null,
    email: null,
    phone: null,
    company: null,
    address: null,
    locality: null,
    postal_code: null,
    region_id: null,
    region: _.clone(region)
};

let user = {
    id: null,
    // first_name: null,
    // last_name: null,
    email: null,
    // phone: null,
    // company: null,
    // address: null,
    // locality: null,
    // postal_code: null,
    // region: _.clone(region),
    // role: null,
    roles: null,
    contact: _.clone(contact),
    created_at: _.clone(timestamp),
    updated_at: _.clone(timestamp)
};

let inspector = {
    user: _.clone(user),
    inspector_license: null,
    inspections: {
        data: []
    }
};

let status = {
    id: null,
    typename: null,
    name: null
};

let inspection = {
    id: null,
    token: null,
    region_id: null,
    parcels: null,
    inspector: _.clone(inspector),
    user: _.clone(user),
    status: _.clone(status),
    region: _.clone(region),
    contact: _.clone(contact),
    created_at: _.clone(timestamp),
    updated_at: _.clone(timestamp)
};

let models = {
    country: country,
    region: region,
    landowner: landowner,
    property: property,
    plan: plan,
    user: user,
    contact: contact,
    inspector: inspector,
    inspection: inspection
};

function mapRelationships (map) {
    let relationships = {};

    _.forIn(map, (v, k) => {
        if (models.hasOwnProperty(k)) {
            let r = { [k]: _.cloneDeep(models[k]) };

            if (_.isObject(v)) {
                r[k] = _.assign(r[k], mapRelationships(v));
            }

            relationships = _.assign(relationships, r);
        }
    });

    return relationships;
}

export default {
    map (base, relationships = {}) {
        if (!models.hasOwnProperty(base)) {
            console.error('Invalid base model name.');
            return;
        }

        return _.assign(_.cloneDeep(models[base]), mapRelationships(relationships));
    },

    getTimestamp () {
        return _.clone(timestamp);
    }
};



// WEBPACK FOOTER //
// ./src/assets/js/schema.js